import { Link } from "react-router-dom"

type Prop = {
  to : string,
  className? : string,
  children? : JSX.Element | string
}

const NavbarChild = ({
    to,
    className = "",
    children
  } : Prop)=>{
    const isChildString = typeof children === 'string'
  return (
    <li className="flex items-center">
      <Link className={className + (isChildString && " opacity-70 hover:opacity-100 font-bold text-sm")} to={to}>
        {children}
      </Link>
    </li>
  )
}

export default NavbarChild;